export const msalConfig = {
    auth: {
      clientId: "db70681c-9071-4a1d-b8a8-7b7a11c23511",
      authority: "https://login.microsoftonline.com/dda03f48-c523-4601-84cf-8718a9851532",
      redirectUri: "https://booking.bernard.vn/admin",
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true, // Recommended for IE11 or Edge
    },
  };